import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.js";
import { initUrlRouting } from "./logic/routing/urlRouting.js";
import App from "./App.jsx";

initUrlRouting();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
